import { computed } from 'mobx';

export default class DataSeriesModel {
  id;
  store;

  constructor(store, dataSeries) {
    this.store = store;
    this.id = +dataSeries.id;
    this.name = dataSeries.name;
    this.station_id = dataSeries.station_id;
    this.parameter_id = dataSeries.parameter_id;
    this.parameter_unit_id = dataSeries.parameter_unit_id;
    this.parameter_unit_name = dataSeries.parameter_unit_name;


    this.parameter_unit = this.store.parameterUnitStore.resolveItem({
      id: dataSeries.parameter_unit && dataSeries.parameter_unit.id,
      name: dataSeries.parameter && dataSeries.parameter.unit_name,
      symbol: dataSeries.parameter && dataSeries.parameter.unit_symbol,
    });
    this.qc_rules = dataSeries.qc_rules;

    this.interval = dataSeries.interval;
    this.start_time = dataSeries.start_time;
    this.tolerance = dataSeries.tolerance;
    this.table = dataSeries.table || 0;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      parameter_id: this.parameter_id,
      parameter_unit_id: this.parameter_unit_id,

      parameter_unit: this.parameter_unit,
      qc_rules: this.qc_rules,

      interval: this.interval,
      start_time: this.start_time,
      tolerance: this.tolerance,
      table: this.table || 0,

      station_id: this.station_id
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.parameter_id = json.parameter_id;
    this.parameter_unit_id = json.parameter_unit_id;

    this.parameter_unit = json.parameter_unit;
    this.qc_rules = json.qc_rules;

    // this.parameter_unit = this.store.parameterUnitStore.resolveItem({
      // id: json.parameter_unit_id,
      // name: json.parameter_unit_name,
      // symbol: json.parameter_unit_symbol,
    // });

    this.interval = json.interval;
    this.start_time = json.start_time;
    this.tolerance = json.tolerance;
    this.table = json.table || 0;
    this.station_id = json.station_id;
  }
}



// WEBPACK FOOTER //
// ./src/models/DataSeriesModel.js